// extracted by mini-css-extract-plugin
module.exports = {"container":"BP0hJqEg","avatar":"PCETrn0g","user":"tLaZRbyn","name":"LvpAy17R","id":"_H2gwkqQ"};